<router-outlet></router-outlet>
<app-loader-spinner></app-loader-spinner>